var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftaidArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.36148 11.7193C4.65592 9.61167 13.351 7.02309 25.4951 10.1161",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7344 4.19764L25.2446 9.51379C25.6548 9.9973 25.5172 10.7356 24.9604 11.0389L18.9588 14.3078",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgGiftaidArrow;